import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { MeetingSummaryAgentContent } from './Content/MeetingSummaryAgentContent'
import { useMeetingSummary, useMeetingSummaryExportToPDF } from './hooks'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import {
  selectMeetingSummaryAgentLoading,
  selectMeetingSummaryAgentPollingEnabled,
  selectMeetingSummaryAgentShouldPoll,
  selectMeetingSummaryAgentShowSidebar,
  selectMeetingSummaryExists,
  startMeetingSummaryAgentPolling,
  stopMeetingSummaryAgentPolling,
} from '../../../../../store/meetingSummaryAgent/meetingSummaryAgent'
import { MeetingSummarySidebar } from './Sidebar/MeetingSummarySidebar'
import { Button } from '../../../../../components/Button/Button'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { MeetingSummaryAgentInitialization } from './Initialization/MeetingSummaryAgentInitialization'
import { MeetingSummaryAgentPoller } from './Poller/MeetingSummaryAgentPoller'
import { MeetingSummaryAgentHeader } from './Header/MeetingSummaryAgentHeader'
import './MeetingSummaryAgent.scss'
import { MeetingSummaryAgentLoader } from './Loader/MeetingSummaryAgentLoader'

export const MeetingSummaryAgentState: React.FC = () => {
  const dispatch = useAppDispatch()

  const shouldPoll = useAppSelector(selectMeetingSummaryAgentShouldPoll)

  useEffect(() => {
    if (shouldPoll) {
      dispatch(startMeetingSummaryAgentPolling())
    } else {
      dispatch(stopMeetingSummaryAgentPolling())
    }
  }, [dispatch, shouldPoll])

  return (
    <>
      <MeetingSummaryAgentInitialization />
      <MeetingSummaryAgentPoller />
    </>
  )
}

export const MeetingSummaryAgent: React.FC = () => {
  const isLoading = useAppSelector(selectMeetingSummaryAgentLoading)
  const meetingSummaryExists = useAppSelector(selectMeetingSummaryExists)
  const pollingEnabled = useAppSelector(selectMeetingSummaryAgentPollingEnabled)
  const showSidebar = useAppSelector(selectMeetingSummaryAgentShowSidebar)
  const { meetingSummaryAgentContentRef } = useMeetingSummaryExportToPDF()

  if (isLoading || pollingEnabled) {
    return <MeetingSummaryAgentLoader />
  }

  if (!meetingSummaryExists) {
    return <ManuallyExecuteMeetingSummary />
  }

  return (
    <Container className='d-flex flex-column w-100 mw-100 p-0'>
      <Row className='sticky-top'>
        <Col>
          <MeetingSummaryAgentHeader />
        </Col>
      </Row>

      <Row className='g-3'>
        <Col xs={12} lg={showSidebar ? 8 : 12} ref={meetingSummaryAgentContentRef}>
          <MeetingSummaryAgentContent />
        </Col>
        {showSidebar && (
          <Col xs={12} lg={4}>
            <MeetingSummarySidebar />
          </Col>
        )}
      </Row>
    </Container>
  )
}

export const ManuallyExecuteMeetingSummary: React.FC = () => {
  const { executeMeetingSummary } = useMeetingSummary()
  return (
    <div className='d-flex flex-1 justify-content-center'>
      <ScopedBlock
        scope={{
          scope: 'ai_agent:execute',
          superScope: ['ai_agent:admin'],
        }}
        missingScopeAction={MissingScopeAction.DISABLE}
      >
        <Button variant='primary' className='py-1 px-2' onClick={executeMeetingSummary}>
          <i className='bi bi-arrow-counterclockwise' />
          Create Meeting Summary
        </Button>
      </ScopedBlock>
    </div>
  )
}
